import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { detectDefaultPais, PaisCatalogo } from '../../../core/models/catalogos';
import { VacantesService } from '../../../core/services/vacantes.service';

type Step = 'phone' | 'otp';

@Component({
  selector: 'app-login-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './login-modal.component.html',
})
export class LoginModalComponent {
  private auth = inject(AuthService);
  private vacantesService = inject(VacantesService);

  @Output() closed = new EventEmitter<void>();

  paises: PaisCatalogo[] = [];
  step = signal<Step>('phone');
  loading = signal(false);
  error = signal<string | null>(null);

  countryDial = signal('');
  phoneNumber = signal('');
  otpCode = signal('');

  constructor() {
    this.vacantesService.obtenerPaises().subscribe((paises) => {
      this.paises = paises.filter((pais) => pais.dial.length > 0);
      this.countryDial.set(detectDefaultPais(this.paises)?.dial ?? '');
    });
  }

  close(): void {
    this.closed.emit();
  }

  get fullPhone(): string {
    return `${this.countryDial()}${this.phoneNumber().replace(/\D/g, '')}`;
  }

  sendOtp(): void {
    if (!this.countryDial() || !this.phoneNumber().trim()) {
      this.error.set('Ingresa tu número de WhatsApp.');
      return;
    }
    this.error.set(null);
    this.loading.set(true);
    this.auth.sendOtp(this.fullPhone).subscribe({
      next: () => {
        this.loading.set(false);
        this.step.set('otp');
      },
      error: () => {
        this.loading.set(false);
        this.error.set('No pudimos enviar el código. Intenta de nuevo.');
      },
    });
  }

  verifyOtp(): void {
    if (!this.otpCode().trim()) {
      this.error.set('Ingresa el código que recibiste por WhatsApp.');
      return;
    }
    this.error.set(null);
    this.loading.set(true);
    this.auth.verifyOtp(this.fullPhone, this.otpCode()).subscribe({
      next: () => {
        this.loading.set(false);
        this.close();
      },
      error: () => {
        this.loading.set(false);
        this.error.set('Código inválido o expirado. Intenta de nuevo.');
      },
    });
  }

  backToPhone(): void {
    this.step.set('phone');
    this.otpCode.set('');
    this.error.set(null);
  }
}
